import { ReactNode } from 'react';

export interface IFeedbackSectionRejectedOptions {
  illustration: ReactNode;
  textContent: {
    description: string;
    form?: ReactNode;
    subHeading: string;
    title: string;
  };
}

interface IFeedbackSectionRejectedProps
  extends IFeedbackSectionRejectedOptions {}

/**
 * -----------------------------------------------------------------------------
 * It renders a rejected feedback section with a illustration and text content
 */
export function FeedbackSectionRejected({
  illustration,
  textContent,
}: Readonly<IFeedbackSectionRejectedProps>) {
  const { description, title, subHeading, form } = textContent;

  return (
    <div
      className="
        flex items-center justify-center border-b border-t border-gray-50
        px-4 py-5
      "
    >
      <div className="flex flex-col items-center gap-2 sm:flex-row">
        <div className="max-w-48">{illustration}</div>
        <div className="text-center">
          <div
            className="
              text-base uppercase tracking-widest text-gray-900
            "
          >
            {title}
          </div>

          {subHeading ? (
            <div
              className="
                inline-flex gap-1 pt-2 text-lg font-bold text-red-700
              "
            >
              {subHeading}
            </div>
          ) : null}
          <div className="max-w-72 m-auto pt-2 text-xs text-red-800">
            {description}
          </div>
          {form ? <div>{form}</div> : null}
        </div>
      </div>
    </div>
  );
}
